import type { QueryKey } from '@tanstack/react-query';
import {
  getIsPrimary,
  getPrimaryCount,
  type OnSetPrimaryInvalidator,
} from '../NarrativeInvalidationBoundary';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import type { useNarrative } from '../../hooks/useNarrative';

export const handleOnSetPrimary =
  (queryKey: QueryKey): OnSetPrimaryInvalidator =>
  ({ queryClient, invalidateExcept }, actionPayload) => {
    invalidateExcept(['narrative-view']);
    queryClient.setQueryData<ResolvedQueryData<typeof useNarrative>>(
      queryKey,
      (state) => {
        if (!state) return;

        return {
          ...state,
          narrative: {
            ...state.narrative,
            isPrimary: getIsPrimary(state.narrative, actionPayload),
            primaryCount: getPrimaryCount(state.narrative, actionPayload),
          },
        };
      }
    );
  };
